import enAuth from "./enAuth";
import enEntities from "./enEntities";

export default {
  ...enAuth,
  ...enEntities,
  common: {
    yes: "Yes",
    no: "No",
    closePanel: "Close panel",
    resizePanel: "Resize panel",
    copyMarkdown: "Copy content as Markdown",
    copyMarkdownDone: "Content copied",
    downloadMarkdown: "Download as Markdown",
  },
  menu: {
    title: "PM Admin",
    editMode: "Edit mode",
    trainings: "Trainings",
    categories: "Categories",
    images: "Images",
    testimonies: "Testimonials",
    trainingVersions: "Versions",
    darkMode: "Theme",
    signOut: "Sign out",
  },
  form: {
    delete: "Delete",
    cancel: "Cancel",
    update: "Update",
    create: "Create",
    back: "Back",
    edit: "Edit",
    add: "Add",
    preview: "Preview",
    none: "None",
    help: "Information",
    reorder: "Reorder",
    moveItemUp: "Move up",
    moveItemDown: "Move down",
    validate: "Validate",
    emptyList: "No items",
    noResults: "No results",
    removeTag: "Remove",
    validationErrors: "There are errors in the form",
  },
  error: {
    noDataMessage: "No data",
  },
  modal: {
    deleteTitle: "Delete item",
    deleteMessage: "Are you sure you want to delete this item?",
    unsavedTitle: "Unsaved changes",
    unsavedMessage: "You have unsaved changes. Close anyway?",
  },
  search: "Search",
  action: {
    error: "An error occurred",
    createdSuccess: "Created successfully",
    createdError: "An error occurred during creation",
    deleteSuccess: "Deleted successfully",
    deleteError: "An error occurred during deletion",
    updateSuccess: "Updated successfully",
    updateError: "An error occurred during update",
  },
  history: {
    title: "History",
    tab: {
      versions: "Versions",
      deleted: "Deleted items",
    },
    empty: "No history yet",
    emptyHint:
      "Creations, changes and deletions of this item will appear here, along with who made them.",
    loadError: "Unable to load the history",
    unknownAuthor: "Unidentified author",
    emptyValue: "empty",
    // A relation id always comes with the name of the record it points to.
    unknownRecord: "record not found",
    deletedRecord: "deleted",
    today: "Today",
    yesterday: "Yesterday",
    action: {
      create: "Created",
      update: "Changed",
      delete: "Deleted",
      restore: "Restored",
      reorder: "Moved",
    },
    // Fallback summary when no field value changed.
    summary: {
      create: "Initial content",
      update: "No field changed",
      delete: "Item deleted",
      restore: "State restored",
      reorder: "Position changed",
    },
    // Context line above the detail.
    detail: {
      change: "Changed by {{author}} on {{date}}",
      create: "Content at creation, by {{author}} on {{date}}",
      delete: "Content when deleted, by {{author}} on {{date}}",
      restore: "Content recreated by {{author}} on {{date}}",
    },
    collection: {
      topics: "Topic",
      topicParts: "Part",
      topicPartQuestions: "Question",
      testimonies: "Testimony",
      trainingVersions: "Training version",
    },
    // Labels for technical fields absent from the forms.
    field: {
      trainingId: "Training",
      topicId: "Topic",
      topicPartId: "Part",
      introduction: "Introduction",
      relatedTestimonyIds: "Related testimonies",
      timing: "Duration",
      categoryId: "Category",
    },
    compareCurrentToggle: "Compare with the current state",
    compareWithThis: "Compare with this version ({{date}})",
    clearComparison: "Back to the default comparison",
    currentState: "The current state",
    noDifference: "No difference between these two states",
    markupOnly: "formatting only",
    showReorders: "Show moves ({{count}})",
    hideReorders: "Hide moves",
    restore: "Restore",
    restoreThisState: "Restore this state",
    restoreVersionOf: "Restore the state of {{date}}",
    confirmRestoreTitle: "Restore this state",
    confirmRestoreMessage:
      "The current content will be replaced with the selected version. The operation is recorded in the history, so you can go back.",
    confirmRestoreDeletedTitle: "Restore this item",
    confirmRestoreDeletedMessage:
      "Recreate “{{label}}” from its last known state?",
    confirmRestoreDeletedWithChildrenMessage:
      "Recreate “{{label}}” from its last known state? The {{count}} items deleted along with it will be restored too.",
    restoreSuccess: "State restored",
    restoreSuccessWithChildren: "Item restored, along with {{count}} related item(s)",
    restoreError: "Restoration failed",
    restoreNotRecovered:
      "Some content could not be recovered: {{fields}}. It no longer exists.",
    restoreChildrenFailed: "{{count}} related item(s) could not be restored.",
    error: {
      parentMissing:
        "The parent item no longer exists: restore it first to be able to restore this one.",
      forbidden: "You do not have the rights required for this restoration.",
      trainingNotResolved:
        "Unable to link this item to a training: its parent was most likely deleted. Restore the parent first.",
      invalidSnapshot: "This version is unreadable and cannot be restored.",
      accountDisabled: "Your account has been disabled.",
    },
    noDeletedItems: "No deleted items",
    noDeletedItemsHint:
      "Deleted parts and questions will appear here, with the option to restore them.",
    deletedOn: "deleted on {{date}}",
    lastSeenOn: "last seen on {{date}}",
    restored: "Restored",
    restoredOn: "restored on {{date}} by {{author}}",
    restoredWithParent: "comes back with its parent",
    limitations:
      "An item created and deleted before history tracking was enabled may leave no trace, and deleted images cannot be recovered.",
  },
  validation: {
    required: "This field is required",
    url: "This URL is invalid",
    integer: "This value must contain only numbers",
    requiredMin: "This field must contain at least {{count}} characters",
    requiredMax: "This field must contain maximum {{count}} characters",
    arrayRequired: "At least one item is required",
    arrayMin: "At least {{count}} items are required",
    imageValidation: "An image is required",
    noNewLines: "This field must not contain new lines",
  },
};
